/* Polsk katalog for locale-invoice-list-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'inv.title': 'Lista faktur',
  'inv.titleHelp': 'Przegląd faktur, ofert, potwierdzeń zamówień i faktur korygujących za wybrany rok obrotowy.',
  'inv.searchPh': 'Szukaj po numerze faktury, kliencie lub kwocie',
  'inv.searchHelp': 'Przeszukaj listę po numerze faktury, nazwie klienta, kwocie faktury, kwocie netto, kwocie zapłaconej lub pozostałej.',
  'inv.downloadHelp': 'Pobierz listę dla wybranej karty i filtra.',
  'inv.addHelp': 'Utwórz nową fakturę.',
  'inv.add': 'Nowa faktura',
  'inv.filterHelp': 'Filtruj listę według statusu, typu dokumentu, daty, okresu, kwoty i archiwum.',
  'inv.tabsHelpTitle': 'Typy dokumentów',
  'inv.tabsHelp': 'Przełączaj między Fakturą, Szkicem, Ofertą/Potwierdzeniem zamówienia, Fakturą korygującą i Raportem sprzedaży.',
  'inv.listHelpTitle': 'Lista faktur',
  'inv.listHelp': 'Każdy wiersz to jeden dokument z backendu. Dotknij wiersza, aby zobaczyć szczegóły i działania.',
  'inv.loading': 'Ładowanie faktur',
  'inv.loadingSub': 'Pobieranie danych z backendu.',
  'inv.noMatch': 'Brak wyników',
  'inv.noMatchSub': 'Wypróbuj inną kartę lub wyczyść filtr.',
  'inv.backToVouchers': 'Wróć do transakcji',
  'inv.type.invoice': 'Faktura',
  'inv.type.quote': 'Oferta',
  'inv.type.orderConfirmation': 'Potwierdzenie zamówienia',
  'inv.type.creditNote': 'Faktura korygująca',
  'inv.type.unknown': 'Dokument',
  'inv.tab.salesReport': 'Raport sprzedaży',
  'inv.importHistory.tab': 'Zaimportowana historia',
  'inv.importHistory.loading': 'Pobieranie zaimportowanej historii faktur …',
  'inv.importHistory.error': 'Nie udało się pobrać zaimportowanej historii faktur.',
  'inv.importHistory.readOnly': 'To historia tylko do odczytu z poprzedniego systemu. Wpisy nie wpływają na księgowanie ani VAT i nie mają w Plumme działań fakturowych.',
  'inv.importHistory.documents': 'Dokumenty',
  'inv.importHistory.year': 'Zaimportowana historia za {year}',
  'inv.importHistory.netSales': 'Sprzedaż netto',
  'inv.importHistory.customers': 'Klienci',
  'inv.importHistory.creditNotes': 'Faktury korygujące',
  'inv.importHistory.netIncluded': 'Odjęto od sprzedaży netto',
  'inv.importHistory.search': 'Szukaj po numerze faktury lub kliencie',
  'inv.importHistory.empty': 'Brak zaimportowanych szczegółów faktur za ten rok',
  'inv.importHistory.emptySub': 'Zaimportowane dane księgowe są nadal używane w raportach i poradach, jeśli istnieją.',
  'inv.importHistory.detailTitle': 'Szczegóły z pliku importu',
  'inv.importHistory.dueDate': 'Termin płatności',
  'inv.importHistory.paidDate': 'Data rozliczenia',
  'inv.importHistory.remaining': 'Do zapłaty',
  'inv.importHistory.lines': 'Zaimportowane pozycje',
  'inv.importHistory.noLines': 'System źródłowy dostarczył dla tego dokumentu tylko sumy faktury.',
  'inv.importHistory.markSettled': 'Oznacz jako rozliczoną',
  'inv.importHistory.reopenStatus': 'Otwórz status ponownie',
  'inv.importHistory.manualSettledNote': 'Oznaczono jako rozliczoną w Plumme bez księgowania.',
  'inv.importHistory.settledToast': 'Zaimportowana faktura została oznaczona jako rozliczona.',
  'inv.importHistory.reopenedToast': 'Zaimportowana faktura została ponownie otwarta.',
  'inv.importHistory.statusError': 'Nie udało się zaktualizować zaimportowanej faktury.',
  'inv.importHistory.sourceNote': 'Zaimportowano z poprzedniego systemu – dokument znajduje się w pliku importu.',
  'inv.importHistory.creditReference': 'Zaimportowana faktura korygująca z poprzedniego systemu – koryguje fakturę {number}.',
  'inv.importHistory.creditedReference': 'Zaimportowano z poprzedniego systemu · skorygowano fakturą korygującą {number}',
  'inv.importHistory.reanalysisTitle': 'Zaimportowaną historię faktur trzeba przeanalizować ponownie',
  'inv.importHistory.reanalysisBody': 'Zapisana analiza pochodzi sprzed odczytywania faktur korygujących z osobnych arkuszy. Dane źródłowe nie zostaną zmienione.',
  'inv.importHistory.reanalysisAction': 'Przejdź do ponownej analizy',
  'inv.importHistory.rowSource': 'Zaimportowano z poprzedniego systemu',
  'adv.sales.importedHistoryNote': 'Analiza łączy zaksięgowane faktury Plumme z historią sprzedaży tylko do odczytu z importu. Faktury korygujące zostały odjęte. {coverage}',
  'adv.sales.importedTotalsCoverage': 'Import zawiera sumy faktur, ale nie zawiera pozycji produktowych dla wszystkich dokumentów.',
  'adv.sales.importedLinesCoverage': 'Import zawiera także pozycje faktur dla części historii.',
  'inv.tab.drafts': 'Szkice',
  'inv.filterDocType': 'Typ dokumentu',
  'inv.filterArchive': 'Archiwum',
  'inv.filterSeeArchived': 'Pokaż zarchiwizowane',
  'inv.status.draft': 'Szkic',
  'inv.status.created': 'Niewysłana',
  'inv.status.sent': 'Wysłana',
  'inv.status.accepted': 'Zaakceptowana',
  'inv.status.confirmed': 'Potwierdzone',
  'inv.status.paid': 'Zapłacona',
  'inv.status.unpaid': 'Niezapłacona',
  'inv.status.overdue': 'Po terminie',
  'inv.status.credited': 'Skorygowana',
  'inv.kpi.invoiceCount': 'Faktury',
  'inv.kpi.invoiceCount.help': 'Liczba faktur utworzonych w wybranym roku, niezależnie od statusu.',
  'inv.kpi.revenue': 'Obrót',
  'inv.kpi.revenue.help': 'Suma wszystkich faktur bez VAT w roku.',
  'inv.kpi.notSent': 'Niewysłane',
  'inv.kpi.notSent.help': 'Faktury zapisane jako szkice, oczekujące na wysłanie.',
  'inv.kpi.credited': 'Skorygowane',
  'inv.kpi.credited.help': 'Liczba faktur korygujących.',
  'inv.kpi.quotes': 'Oferty',
  'inv.kpi.quotes.help': 'Liczba ofert w roku.',
  'inv.kpi.accepted': 'Zaakceptowane',
  'inv.kpi.accepted.help': 'Liczba ofert zaakceptowanych przez klienta.',
  'inv.kpi.orders': 'Potwierdzenia zamówień',
  'inv.kpi.orders.help': 'Liczba potwierdzeń zamówień w roku.',
  'inv.kpi.creditNotes': 'Faktury korygujące',
  'inv.kpi.creditNotes.help': 'Liczba faktur korygujących w roku.',
  'inv.kpi.value': 'Wartość',
  'inv.kpi.value.help': 'Łączna wartość bez VAT dokumentów na tej karcie.',
  'inv.kpi.amount': 'Kwota',
  'inv.kpi.amount.help': 'Łączna kwota bez VAT faktur korygujących.',
  'inv.kpi.sent': 'Wysłane',
  'inv.kpi.sent.help': 'Liczba dokumentów wysłanych do klienta.',
  'inv.kpi.confirmed': 'Potwierdzone',
  'inv.kpi.confirmed.help': 'Potwierdzenia zamówień potwierdzone przez klienta.',
  'inv.kpi.drafts': 'Szkice',
  'inv.kpi.drafts.help': 'Dokumenty, które nie zostały jeszcze wysłane.',
  'inv.kpi.potentialRevenue': 'Możliwy obrót',
  'inv.kpi.potentialRevenue.help': 'Łączna wartość szkiców, które mogą zostać wysłane.',
  'inv.kpi.customers': 'Klienci',
  'inv.kpi.customers.help': 'Liczba unikalnych klientów w szkicach.',
  'inv.kpi.history': 'Wiek',
  'inv.kpi.history.help': 'Jak długo czeka najstarszy szkic.',
  'inv.kpi.sub.totalYear': 'Łącznie w tym roku',
  'inv.kpi.sub.exVat': 'Bez VAT',
  'inv.kpi.sub.waiting': 'Czeka na Ciebie',
  'inv.kpi.sub.creditNotes': 'Faktury korygujące',
  'inv.kpi.sub.started': 'Rozpoczęte dokumenty',
  'inv.kpi.sub.uniqueCustomers': 'Unikalni klienci',
  'inv.kpi.sub.oldestDraft': 'Najstarszy szkic',
  'inv.kpi.sub.noDrafts': 'Brak szkiców',
  'inv.kpi.sub.none': 'Brak',
  'inv.kpi.sub.days': 'Dni: {n}',
  'inv.kpi.sub.sentQuotes': 'Wysłane oferty',
  'inv.kpi.sub.accepted': 'Zaakceptowane',
  'inv.kpi.sub.confirmed': 'Potwierdzone',
  'inv.kpi.sub.notSent': 'Niewysłane',
  'inv.kpi.sub.sent': 'Wysłane',
  'inv.col.document': 'Dokument',
  'inv.col.invoice': 'Faktura',
  'inv.col.date': 'Data',
  'inv.col.net': 'Netto',
  'inv.col.amount': 'Kwota',
  'inv.col.status': 'Status',
  'inv.col.number': 'Nr',
  'inv.col.customer': 'Klient',
  'inv.netInline': 'Netto {amount}',
  'inv.draftPlaceholder': 'SZKIC',
  'inv.detail.dueTitle': 'Termin płatności',
  'inv.detail.dueHelp': 'Data, do której dokument obowiązuje lub do której należy zapłacić.',
  'inv.detail.statusHelp': 'Płatności pochodzą z zaksięgowanych wpisów PaymentEntry. Oferty i potwierdzenia zamówień pokazują status realizacji.',
});
